import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-background-50">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20amber%20and%20gold%20tones%2C%20soft%20film%20grain%20texture%2C%20blurred%20movie%20theater%20ambiance%20with%20subtle%20light%20beams%2C%20elegant%20dark%20atmosphere%20with%20gentle%20bokeh%20effects%2C%20artistic%20and%20sophisticated%20visual%20style%20suitable%20for%20a%20premium%20streaming%20platform%20hero%20background&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="爱豆影视 - 影视平台背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 md:pt-24 pb-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-500 bg-accent-500/10 border border-accent-500/20 rounded-full mb-4">
              {siteInfo.tagline}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-3">
              {siteInfo.h1}
            </h1>

            <p className="text-base md:text-lg text-accent-400 font-medium mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={siteInfo.ctaPrimary.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(siteInfo.ctaPrimary.href); }}
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                {siteInfo.ctaPrimary.text}
              </a>
              <a
                href={siteInfo.ctaSecondary.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(siteInfo.ctaSecondary.href); }}
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold text-foreground-800 bg-background-100/80 hover:bg-background-200/80 border border-background-300/60 rounded-lg transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                {siteInfo.ctaSecondary.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-300/40 shadow-2xl shadow-black/20">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20featuring%20elements%20of%20Chinese%20drama%2C%20warm%20golden%20spotlight%20on%20a%20theater%20stage%20with%20flowing%20silk%20curtains%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20elegant%20and%20artistic%20composition%2C%20rich%20amber%20and%20crimson%20color%20palette%2C%20premium%20entertainment%20platform%20visual&width=1200&height=800&seq=hero-visual-01&orientation=portrait"
                alt="爱豆影视 - 热播剧集主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="px-2 py-1 text-xs font-medium text-background-50 bg-primary-500/90 rounded-md whitespace-nowrap">
                  热播推荐
                </span>
                <span className="text-sm font-medium text-foreground-950">
                  剑啸九州 · 星光之城 · 暗影追踪
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <a
          href="#media"
          onClick={(e) => { e.preventDefault(); handleNavClick('#media'); }}
          className="flex flex-col items-center gap-1 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下探索</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}